import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'create',
  async getComponent (nextState) {
    const {
      default: CreateContainer
    } = await import(/* webpackChunkName: "create" */ './containers/CreateContainer')
      .catch(handleChunkLoadError);
    return CreateContainer;
  },
  children: [
    {
      path: '',
      async getComponent (nextState) {
        const {
          default: CreatePage
        } = await import(/* webpackChunkName: "create" */ './containers/CreatePage')
          .catch(handleChunkLoadError);
        return CreatePage;
      },
      getData ({ context: { props } }) {
        return props;
      }
    },
    {
      path: 'project',
      async getComponent (nextState) {
        const {
          default: CreateProject
        } = await import(/* webpackChunkName: "project" */ './components/CreateProject')
          .catch(handleChunkLoadError);
        return CreateProject;
      },
      getData ({ context: { props } }) {
        return props;
      }
    },
    {
      path: 'review',
      async getComponent (nextState) {
        const {
          default: CreateReview
        } = await import(/* webpackChunkName: "review" */ './components/CreateReview')
          .catch(handleChunkLoadError);
        return CreateReview;
      },
      getData ({ context: { props } }) {
        return props;
      }
    }
  ]
});
